import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { PartnerProductInsightsAPIPartner } from 'src/services/partner-product-insights-api/types/PartnerProductInsightsAPIPartner';
import { adaptPartnerInsightsForStore } from './adapters/adaptPartnerInsightsForStore';
import type { PartnerState } from './types';

export type { PartnerState } from './types';

export const initialState: PartnerState = {
  insights: null,
};

const partnerSlice = createSlice({
  name: 'partner',
  initialState,
  reducers: {
    setPartnerInsights: (
      state,
      { payload }: PayloadAction<PartnerProductInsightsAPIPartner | null>,
    ) => {
      state.insights = payload ? adaptPartnerInsightsForStore(payload) : null;
    },
  },
});

export const { setPartnerInsights } = partnerSlice.actions;
export const { reducer } = partnerSlice;
